import { SteemActionType } from '@popup/steem/actions/action-type.enum';
export const PhishingReducer = (state = [], { type, payload }) => {
    switch (type) {
        case SteemActionType.FETCH_PHISHING_ACCOUNTS:
            return payload;
        default:
            return state;
    }
};
